import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import moment from 'moment';
import {
  Box, Typography, Card, CardContent, Grid, Chip, CircularProgress, Alert,
  IconButton, Stack, useMediaQuery
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { getQuestionnaireById } from '../API/questionnaire';

const InfoItem = ({ label, value }) => (
  <Grid item xs={12} sm={6}>
    <Typography variant="caption" color="text.secondary" display="block">{label}</Typography>
    <Typography variant="body2" fontWeight={500} sx={{ mb: 1.5 }}>{value ?? '-'}</Typography>
  </Grid>
);

const ExecutiveQuestionnaireDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:800px)');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await getQuestionnaireById(id);
        setData(res.data?.data || res.data);
      } catch (err) {
        setError('Gagal memuat data pendataan');
      } finally {
        setLoading(false);
      }
    };
    if (id) fetchData();
  }, [id]);

  if (loading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}><CircularProgress /></Box>;
  }

  if (error || !data) {
    return <Alert severity="error" sx={{ m: 2 }}>{error || 'Data tidak ditemukan'}</Alert>;
  }

  const fields = [
    ['Status Rumah', data.statusrumah],
    ['Nomor Blok', data.nomorUrut],
    ['Nomor Rumah Pada Peta', data.nomorRumahPadaPeta],
    ['Nama Lengkap KK', data.namaLengkapKK],
    ['Tanggal Lahir', data.tanggallahir ? moment(data.tanggallahir).format('DD/MM/YYYY') : null],
    ['Jenis Kelamin', data.jenisKelamin],
    ['Nomor KK', data.nomorKK],
    ['Nomor KTP', data.nomorKTP],
    ['Alamat Rumah', data.alamatRumah],
    ['Kecamatan', data.kecamatan],
    ['Desa/Kelurahan', data.desaKelurahan],
    ['Pendidikan Terakhir', data.pendidikanTerakhir],
    ['Pekerjaan', data.pekerjaan],
    ['Penghasilan', data.penghasilan],
    ['Jenis Rumah', data.modelRumah],
    ['Luas Rumah', data.luasRumah],
    ['Luas Tanah', data.luasTanah],
    ['Titik Koordinat', data.titikKoordinatRumah],
    ['Tanggal Pendataan', data.tanggalPendataan],
    ['Surveyor', data.Admin?.username],
    ['Skor', data.score],
    ['Kategori', data.kategori],
    ['Catatan', data.catatan],
    ['Status Validasi Bantuan', data.verifikasiBantuan],
  ];

  return (
    <Box sx={{ maxWidth: 900, mx: 'auto' }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
        <IconButton onClick={() => navigate(-1)} size="small"><ArrowBack /></IconButton>
        <Box sx={{ flex: 1 }}>
          <Typography variant={isMobile ? 'subtitle1' : 'h6'} fontWeight={700}>
            Detail Pendataan Rumah
          </Typography>
          <Typography variant="caption" color="text.secondary">{data.namaLengkapKK}</Typography>
        </Box>
        <Chip label={data.kategori} color="primary" size="small" />
      </Stack>

      <Card sx={{ borderRadius: 3 }}>
        <CardContent>
          <Grid container spacing={1}>
            {fields.map(([label, value]) => (
              <InfoItem key={label} label={label} value={value} />
            ))}
          </Grid>

          {data.fotoRumah && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="caption" color="text.secondary" display="block" gutterBottom>Foto Rumah</Typography>
              <Box
                component="img"
                src={`${process.env.REACT_APP_URL}/${data.fotoRumah}`}
                alt="Foto Rumah"
                sx={{ width: '100%', maxHeight: 300, objectFit: 'contain', borderRadius: 2 }}
              />
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default ExecutiveQuestionnaireDetail;
